import styled from 'styles/styled';

/* ---------- Layout ---------- */

export const Wrap = styled.div`
  width: calc(100% - 50px);
  height: 100%;
  float: right;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  @media (max-width: 720px) {
    width: calc(100% - 45px);
  }
`;

export const TabStrip = styled.div`
  display: flex;
  gap: 14px;
  border-bottom: 1px solid #2A2E34;
  margin-bottom: 8px;
`;

export const TabBtn = styled.button`
  background: transparent;
  border: none;
  appearance: none;
  cursor: pointer;
  color: #7A7E8C;
  font-size: 12px;
  font-weight: 500;
  padding: 6px 0;
  border-bottom: 2px solid transparent;
  transition: color 120ms ease, border-color 120ms ease;
  &.active {
    color: #EFEFEF;
    font-weight: 700;
    border-bottom-color: #52D381;
  }
`;

export const ListWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding-right: 2px;
`;

export const EmptyState = styled.div`
  text-align: center;
  font-size: 12px;
  color: #7A7E8C;
  padding: 24px 12px;
`;

export const LoadWrap = styled.div`
  display: block;
  width: 30px;
  height: 30px;
  animation: rotation 800ms infinite linear;
  border-radius: 999px;
  box-shadow: 0.6px 0.5px 0 0.6px #52D381;
  margin: 40px auto;
  @keyframes rotation {
    from { transform: rotate(0deg); }
    to   { transform: rotate(359deg); }
  }
`;

export const WrapTPSL = styled.div`
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  h3, p { display: none; }
  button { width: 100%; }
`;

/* ---------- Card ---------- */

export const Card = styled.div`
  background: #15191E;
  border-radius: 10px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const CardHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const PairCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

export const PairIcon = styled.div<{ $src?: string }>`
  width: 22px;
  height: 22px;
  border-radius: 999px;
  background-color: #292B2E;
  background-image: url(${p => p.$src});
  background-size: cover;
  background-position: center;
  flex-shrink: 0;
`;

export const PairName = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: #EFEFEF;
  letter-spacing: 0.02em;
`;

export const SideLev = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
`;

export const SideBadge = styled.span<{ $side: 'long' | 'short' }>`
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 2px 6px;
  border-radius: 4px;
  ${p =>
    p.$side === 'long'
      ? `background: rgba(82,211,129,0.12); color: #52D381;`
      : `background: rgba(255,103,130,0.12); color: #FF6782;`}
`;

export const LevBadge = styled.span`
  font-size: 11px;
  font-weight: 700;
  color: #EFEFEF;
  background: #292B2E;
  padding: 2px 6px;
  border-radius: 4px;
`;

export const StatusBadge = styled.span<{ $tone: 'bull' | 'muted' }>`
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 3px 8px;
  border-radius: 999px;
  ${p =>
    p.$tone === 'bull'
      ? `background: rgba(82,211,129,0.12); color: #52D381;`
      : `background: #292B2E; color: #A7A8B2;`}
`;

/* ---------- Body rows ---------- */

export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 12px;
  align-items: baseline;
`;

export const L = styled.span`
  font-size: 11px;
  color: #7A7E8C;
  text-align: right;
  font-weight: 400;
  white-space: nowrap;
`;

export const V = styled.span`
  font-size: 12px;
  color: #EFEFEF;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  text-align: left;
  &.bull { color: #52D381; }
  &.bear { color: #FF6782; }
  &.muted { color: #A7A8B2; font-weight: 500; }
`;

/* ---------- Footer ---------- */

export const CardFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TPSLBox = styled.button`
  appearance: none;
  border: none;
  cursor: pointer;
  text-align: left;
  background: #292B2E;
  border-radius: 8px;
  padding: 8px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  transition: background 120ms ease;
  &:hover { background: #2F3236; }
`;

export const TPSLRow = styled.div`
  display: grid;
  grid-template-columns: 28px 1fr;
  gap: 8px;
  align-items: baseline;
`;

export const TPSLLabel = styled.span<{ $tone: 'bull' | 'bear' }>`
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${p => (p.$tone === 'bull' ? '#52D381' : '#FF6782')};
`;

export const TPSLValue = styled.span`
  font-size: 11px;
  font-weight: 500;
  color: #EFEFEF;
  font-variant-numeric: tabular-nums;
  &.muted { color: #7A7E8C; font-weight: 400; }
`;

export const TPSLHint = styled.span`
  font-size: 9px;
  color: #7A7E8C;
  text-align: right;
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

export const ActionRow = styled.div`
  display: flex;
  gap: 8px;
`;

export const ActionBtn = styled.button<{ $tone?: 'danger' | 'neutral' }>`
  appearance: none;
  border: none;
  cursor: pointer;
  flex: 1;
  height: 40px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.02em;
  transition: filter 120ms ease, transform 120ms ease;
  ${p =>
    p.$tone === 'danger'
      ? `background: #FF6782; color: #0A0A0A;`
      : `background: #292B2E; color: #EFEFEF;`}
  &:hover { filter: brightness(1.08); }
  &:active { transform: translateY(1px); }
`;

/* ---------- Confirm strip ---------- */

export const ConfirmRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 4px 0;
`;

export const ConfirmText = styled.p`
  font-size: 12px;
  color: #EFEFEF;
  text-align: center;
  line-height: 1.4;
  margin: 0;
`;

export const ConfirmBtns = styled.div`
  display: flex;
  gap: 8px;
`;

/* ---------- History row (compact) ---------- */

export const HistoryItem = styled.div`
  background: #15191E;
  border-radius: 10px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const HistoryHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const HistoryDate = styled.span`
  font-size: 10px;
  color: #7A7E8C;
  font-weight: 400;
  white-space: nowrap;
`;

export const HistoryBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
